import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/sendService/sendTemplate/select`,
    method: "POST",
    data,
  });
}

// 新增
export function addApi(data) {
  return request({
    url: `/sendService/sendTemplate/add`,
    method: "POST",
    data,
  });
}

/* 修改 */
export function updateApi(data) {
  return request({
    url: `/sendService/sendTemplate/update`,
    method: "POST",
    data,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/sendService/sendTemplate/delete`,
    method: "POST",
    data,
  });
}
